import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import {
  applyDecorator,
  getAvailableDecorators,
} from "@/components/doc/right-sidebar/active-node-style/variable/decorators";
import { hasDecorator } from "@/components/expression/utils/decorators/utils";
import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { twMerge } from "@/utils/twMerge";

import type { DecoratorTypeValue } from "@/components/suggestions/providers/data/types";
import type { NodeModel } from "@/models/nodes/types";

type Props = {
  node: NodeModel;
  decoratorType: DecoratorTypeValue;
  className?: string;
};

export const DecoratorToggleButton = observer(function DecoratorToggleButton({
  node,
  decoratorType,
  className,
}: Props) {
  const t = useTranslations();
  const [decorator] = getAvailableDecorators(node, [decoratorType]);

  if (!decorator) {
    return null;
  }

  const title = decorator.intlName ? t(`suggestions.${decorator.intlName}`) : "Decorator";

  return (
    <Sidebar.ToggleButton
      className={twMerge("min-h-full", className)}
      icon={decorator.icon ? <Icon name={decorator.icon} /> : null}
      isActive={hasDecorator(node, decoratorType)}
      aria-pressed={hasDecorator(node, decoratorType)}
      tooltipTitle={title}
      withArrow={false}
      onClick={() => applyDecorator(node, decoratorType)}
    />
  );
});
